<template>

  <div>
    <v-loading color='#093937' :isLoading="loading" :height="50" :width="50" :viewbox="'0 0 50 50'" :cx="25" :cy="25" :r="22" :isHeightAuto="true"></v-loading>
    <div class="images-section" v-if="!loading">
      <draggable v-model="imagesList" group="image" @start="drag=true" @change="reorder" :sort="true" class="draggable-container">

      <div v-for="(image, index) in imagesList" class="col-12 col-md-4 images mb-50" :key="image.id">
        <img :src="image.url" class="img-responsive">
        <div class="visuel-wrapper resp-checklists-img-box">
          <div class="checklists-image-masque">
            <button type="button" class="btn btn-block btn-warning waves-effect waves-classic waves-effect waves-classic"
                    @click.prevent="deleteImage(image, index, type)">
              {{ $t("button.delete") }}
            </button>
          </div>
        </div>
        <textarea-autosize v-if="type !== 'slider'" name="the-space-image-name" class="form-control edit-image-label" :ref="`${type}-${index}`" autofocus="autofocus" v-model="image.label" cols="30" rows="1"/>
      </div>
      </draggable>

    </div>
  </div>
</template>

<script>
import VueTextareaAutosize from 'vue-textarea-autosize';
import Vue from 'vue';
import draggable from 'vuedraggable';


export default {
  name: 'ImagesBox',
  data() {
    return {
      loading: false,
      imagesList: this.images,
    };
  },
  props: [
    'deleteUploadedImage',
    'images',
    'type',
    'imageDeleted',
  ],
  components: {
    VLoading: require('components/loading/loading.vue'),
    draggable,
  },
  mounted() {
    Vue.use(VueTextareaAutosize);
  },
  methods: {
    async deleteImage(image, index, type) {
      this.loading = true;
      await this.$emit('deleteUploadedImage', image, index, type);
    },

    reorder() {
      this.imagesList.forEach((item, index) => {
        item.order = index;
      });
      this.$emit('updateImagesOrder', this.type, this.imagesList);
    },
  },
  watch: {
    imageDeleted(val) {
      if (val) {
        this.loading = false;
      }
    },

    images(newVal) {
      if (newVal) {
        this.imagesList = newVal;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// ImagesBox.vue?78000dde